import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Table, Button} from 'react-bootstrap';
import moment from 'moment';
import {search} from 'react-icons-kit/icomoon/search';
import SvgIcon from 'react-icons-kit';
import ModalDetails from './modalDetails';
import Help from '../../generics/help';

var Config = require('../../../config');

class DiscardSuppliesEntry extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.newDiscard = this.newDiscard.bind(this);
		this.filter = this.filter.bind(this);
		this.viewDetails = this.viewDetails.bind(this);

		this.state = {
			filter:"",
			list:[]
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'supplies_discards?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id'), {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({list:response});
			}
		});
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	newDiscard(){
		this.props.history.push('/supplies_reagents/discard/new');
	}

	filter(row){
		var res = true;

		
		if(row !== null){
			if(
				row.folio !== null &&
				row.user !== null
			){
				if(
					row.folio.indexOf(this.state.filter.toUpperCase()) !== -1 ||
					row.user.indexOf(this.state.filter.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}

		}

		return res;
	}

	viewDetails(e, id){
		this.modal_details.handleShow(id);
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
                    {sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Insumos ->
						Bajas 
					</h5>
				</div>
	                
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<input type="text" className="form-control" name="filter" id="filter" placeholder={"Filtro..."}
							value={this.state.filter} onChange={this.handleChange} />
						
					</div>

					<div className="col-xs-12 col-sm-1 col-sm-offset-9">
						<button type="button" className="btn btn-info" style={{fontSize:"14px"}}
							disabled={!this.props.supplies_discards.create}
							onClick={this.newDiscard}>Nuevo</button>
					</div>
				</div>

				<div className="col-xs-12">
					<Table responsive>
						<thead>
							<tr>
								<th>Folio</th>
								<th>Fecha</th>
								<th>Usuario</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((l,i)=>(
								this.filter(l) ?
									<tr key={i}>
										<td>{l.folio}</td>
										<td>{moment(l.date).format('DD/MM/YYYY')+' '+moment(l.hour, 'H:mm:ss').format('HH:mm')}</td>
										<td>{l.user}</td>
										<td>
											<Button className="btn btn-info btn-xs" title="Eliminar" 
												style={{marginRight:'3px'}} 
												onClick={(e) => this.viewDetails(e, l.id)}>
					                            <SvgIcon icon={search} style={{paddingTop:"3px"}}/>
					                        </Button>
						                </td>
									</tr>
								:null
							))}
						</tbody>
					</Table>
				</div>

				<ModalDetails {...this.props} onRef={ref => this.modal_details = ref} />
			</div>
		)
	}
}

export default translate('translations')(DiscardSuppliesEntry);